import gsap from 'gsap';
import { viewport } from '../viewport';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function init(container = document) {
    const panelsWrappers = Array.from(container.querySelectorAll('.js-panels'))

    ScrollTrigger.matchMedia({
        "(orientation:landscape) and (max-width: 1023px)": function (){
            panelsWrappers.forEach(wrapper => {
                const panels = Array.from(wrapper.querySelectorAll('.js-panel-video'));
                panels.forEach((panel, index) => {
                    const panelSection = panel.closest('.js-panel');
                    const panelContent = panelSection.querySelector('.js-panel-content');
                    if (panelSection.dataset.calcScrollTop) {
                        panelSection.dataset.calcScrollTop = panelSection.offsetTop;
                    }
                    const panelTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: panelSection,
                            start: 'top top',
                            end: () => `+=${viewport.height * 1.2}`,
                            scrub: true,
                            invalidateOnRefresh: true,
                            anticipatePin: 1,
                        }
                    });
                    panelTl.to(panelContent, {y: index !== panels.length -1 ? '-20vh' : '-10vh'})
                })
            });
        },
        "(orientation:portrait) and (max-width: 1023px)": function (){
            panelsWrappers.forEach(wrapper => {
                const panels = Array.from(wrapper.querySelectorAll('.js-panel-video'));
                panels.forEach((panel, index) => {
                    const panelSection = panel.closest('.js-panel');
                    const panelContent = panelSection.querySelector('.js-panel-content');
                    if (panelSection.dataset.calcScrollTop) {
                        panelSection.dataset.calcScrollTop = panelSection.offsetTop;
                    }
                    const panelTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: panelSection,
                            start: 'top top',
                            end: () => `+=${viewport.height * 1.2}`,
                            scrub: true,
                            invalidateOnRefresh: true,
                            anticipatePin: 1,
                        }
                    });

                    // panelTl.to(panelContent, {y: index !== panels.length -1 ? '-80vh' : '-30vh'});
                })
            });
        },
        "(min-width: 1024px)": function() {
            panelsWrappers.forEach(wrapper => {
                const panels = Array.from(wrapper.querySelectorAll('.js-panel-video'));
                panels.forEach((panel, index) => {
                    const panelSection = panel.closest('.js-panel');
                    const panelContent = panelSection.querySelector('.js-panel-content');
                    if (panelSection.dataset.calcScrollTop) {
                        panelSection.dataset.calcScrollTop = panelSection.offsetTop;
                    }
                    const panelTl = gsap.timeline({
                        scrollTrigger: {
                            trigger: panelSection,
                            start: 'top top',
                            end: () => `+=${viewport.height * 1.2}`,
                            scrub: true,
                            invalidateOnRefresh: true,
                            anticipatePin: 1,
                        }
                    });
                    panelTl.to(panelContent, {y: index !== panels.length -1 ? '-80vh' : '-30vh'});
                })
            });
        }
    })

}

const _module = { init }

export default _module;